import React from "react";
import { Navbar, Footer } from "../../components/index.js";
import FotoHeader from "../../assets/2FotoPabrik.jpeg";
import Aplikasi from "../../components/Lowongan/SalesPerson.jsx";
import { Header } from "../../components/CoilAbuPage.jsx/index.js";

const SalesPerson = () => {
  const BgHeader = {
    backgroundImage: `url(${FotoHeader})`,
    backgroundSize: "cover",
    backgroundPosition: "0% 60%",
    overflow: "hidden",
  };
  return (
    <>
      <Navbar />

      <section className="lg:mt-9">
        <Aplikasi />
      </section>
      <Footer />
    </>
  );
};

export default SalesPerson;
